import Cookies, {CookieAttributes} from 'js-cookie';

export type StorageType = string | undefined;

export type PaymentStorageType = {
  orderId: number
  paymentMethod: string
  paymentUrl: string
}

const fiveMins = 1 / 240; // each hour have 10 x 6 min => 24 hours have 10 * 24 = 240 => expires in 6 mins

const cookieOptions : CookieAttributes = {
  sameSite: process.env.NODE_ENV === 'production' ? 'strict': undefined,
  secure: process.env.NODE_ENV === 'production'
};


export const ClientStorage = {
  get token(): StorageType {
    return Cookies.get('token');
  },
  set token(value: StorageType) {
    if (value) {
      Cookies.set('token', value, cookieOptions);
    }
  },
  //
  // get paymentMethod(): StorageType {
  //   return Cookies.get('paymentMethod');
  // },
  // set paymentMethod(value: StorageType) {
  //   if (value) {
  //     Cookies.set('paymentMethod', value, {expires: fiveMins});
  //   }
  // },

  get lang(): StorageType {
    return Cookies.get('lang');
  },
  set lang(value: StorageType) {
    if (value) {
      Cookies.set('lang', value, cookieOptions)
    }
  },

  get orderProcessing(): PaymentStorageType | undefined {
    const result = undefined;

    return result ? JSON.parse(result) : undefined
  },
  set orderProcessing(values: PaymentStorageType | undefined) {
    if (values) {
      Cookies.set('orderProcessing', JSON.stringify(values), {expires: fiveMins, ...cookieOptions}); //expire in 5 min
    }
  },
  clearAll() {
    Cookies.remove('token');
    Cookies.remove('paymentMethod');
  }
};
